/**
 * @generated SignedSource<<b2e581793bc2ea82e30997d7f16f00f2>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FileBrowserEntryKind = "DIRECTORY" | "FILE";
export type ProjectVersionFileKind = "DATA" | "PACKAGE" | "SUBMISSION_EVALUATION" | "TEMPLATE";
export type CompetitionCodeReadmePageQuery$variables = {
  fileKind: ProjectVersionFileKind;
  owner: string;
  slug: string;
};
export type CompetitionCodeReadmePageQuery$data = {
  readonly competitionBySlug: {
    readonly event: {
      readonly event: {
        readonly slug: string;
      };
    };
    readonly id: string;
    readonly useCase: {
      readonly latest: {
        readonly fileByKind: {
          readonly browse: {
            readonly readMeta: {
              readonly kind: FileBrowserEntryKind;
              readonly " $fragmentSpreads": FragmentRefs<"FileViewerFragment">;
            } | null | undefined;
          };
          readonly " $fragmentSpreads": FragmentRefs<"FileBrowserFragment">;
        } | null | undefined;
      } | null | undefined;
    };
  } | null | undefined;
};
export type CompetitionCodeReadmePageQuery = {
  response: CompetitionCodeReadmePageQuery$data;
  variables: CompetitionCodeReadmePageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fileKind"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "owner"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "slug"
},
v3 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "slug"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "owner"
  }
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v7 = [
  {
    "kind": "Variable",
    "name": "kind",
    "variableName": "fileKind"
  }
],
v8 = [
  {
    "kind": "Literal",
    "name": "path",
    "value": "README.md"
  }
],
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "kind",
  "storageKey": null
},
v10 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 100
  }
],
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "contentType",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "contentLength",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/),
      (v2/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "CompetitionCodeReadmePageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*:: as any*/),
        "concreteType": "Competition",
        "kind": "LinkedField",
        "name": "competitionBySlug",
        "plural": false,
        "selections": [
          (v4/*:: as any*/),
          {
            "alias": null,
            "args": (v5/*:: as any*/),
            "concreteType": "EventCompetition",
            "kind": "LinkedField",
            "name": "event",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Event",
                "kind": "LinkedField",
                "name": "event",
                "plural": false,
                "selections": [
                  (v6/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UseCase",
            "kind": "LinkedField",
            "name": "useCase",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ProjectVersion",
                "kind": "LinkedField",
                "name": "latest",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": (v7/*:: as any*/),
                    "concreteType": "ProjectVersionFile",
                    "kind": "LinkedField",
                    "name": "fileByKind",
                    "plural": false,
                    "selections": [
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "FileBrowserFragment"
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FileBrowser",
                        "kind": "LinkedField",
                        "name": "browse",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": (v8/*:: as any*/),
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "readMeta",
                            "plural": false,
                            "selections": [
                              (v9/*:: as any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "args": null,
                                    "kind": "FragmentSpread",
                                    "name": "FileViewerFragment"
                                  }
                                ],
                                "type": "FileBrowserFileEntry",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": "readMeta(path:\"README.md\")"
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*:: as any*/),
      (v2/*:: as any*/),
      (v0/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "CompetitionCodeReadmePageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*:: as any*/),
        "concreteType": "Competition",
        "kind": "LinkedField",
        "name": "competitionBySlug",
        "plural": false,
        "selections": [
          (v4/*:: as any*/),
          {
            "alias": null,
            "args": (v5/*:: as any*/),
            "concreteType": "EventCompetition",
            "kind": "LinkedField",
            "name": "event",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Event",
                "kind": "LinkedField",
                "name": "event",
                "plural": false,
                "selections": [
                  (v6/*:: as any*/),
                  (v4/*:: as any*/)
                ],
                "storageKey": null
              },
              (v4/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UseCase",
            "kind": "LinkedField",
            "name": "useCase",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ProjectVersion",
                "kind": "LinkedField",
                "name": "latest",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": (v7/*:: as any*/),
                    "concreteType": "ProjectVersionFile",
                    "kind": "LinkedField",
                    "name": "fileByKind",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FileBrowser",
                        "kind": "LinkedField",
                        "name": "browse",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": (v10/*:: as any*/),
                            "concreteType": "FileBrowserEntryConnection",
                            "kind": "LinkedField",
                            "name": "readDir",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "FileBrowserEntryEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v11/*:: as any*/),
                                      (v12/*:: as any*/),
                                      (v9/*:: as any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v13/*:: as any*/),
                                          (v14/*:: as any*/)
                                        ],
                                        "type": "FileBrowserFileEntry",
                                        "abstractKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "cursor",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "PageInfo",
                                "kind": "LinkedField",
                                "name": "pageInfo",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "endCursor",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "hasNextPage",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": "readDir(first:100)"
                          },
                          {
                            "alias": null,
                            "args": (v10/*:: as any*/),
                            "filters": [
                              "path"
                            ],
                            "handle": "connection",
                            "key": "FileBrowser_readDir",
                            "kind": "LinkedHandle",
                            "name": "readDir"
                          },
                          {
                            "alias": null,
                            "args": (v8/*:: as any*/),
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "readMeta",
                            "plural": false,
                            "selections": [
                              (v11/*:: as any*/),
                              (v9/*:: as any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v12/*:: as any*/),
                                  (v13/*:: as any*/),
                                  (v14/*:: as any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "downloadUrl",
                                    "storageKey": null
                                  }
                                ],
                                "type": "FileBrowserFileEntry",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": "readMeta(path:\"README.md\")"
                          }
                        ],
                        "storageKey": null
                      },
                      (v4/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  (v4/*:: as any*/)
                ],
                "storageKey": null
              },
              (v4/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "1e05f71f58288ba31a8bcec05f82078c",
    "id": null,
    "metadata": {},
    "name": "CompetitionCodeReadmePageQuery",
    "operationKind": "query",
    "text": "query CompetitionCodeReadmePageQuery(\n  $owner: String!\n  $slug: String!\n  $fileKind: ProjectVersionFileKind!\n) {\n  competitionBySlug(slug: $slug) {\n    id\n    event(slug: $owner) {\n      event {\n        slug\n        id\n      }\n      id\n    }\n    useCase {\n      latest {\n        fileByKind(kind: $fileKind) {\n          ...FileBrowserFragment\n          browse {\n            readMeta(path: \"README.md\") {\n              __typename\n              kind\n              ... on FileBrowserFileEntry {\n                ...FileViewerFragment\n              }\n            }\n          }\n          id\n        }\n        id\n      }\n      id\n    }\n  }\n}\n\nfragment FileBrowserFragment on ProjectVersionFile {\n  browse {\n    readDir(first: 100) {\n      edges {\n        node {\n          __typename\n          name\n          kind\n          ... on FileBrowserFileEntry {\n            contentType\n            contentLength\n          }\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n  }\n  id\n}\n\nfragment FileViewerFragment on FileBrowserFileEntry {\n  name\n  contentType\n  contentLength\n  downloadUrl\n}\n"
  }
};
})();

(node as any).hash = "99789dd02763f18653a28ea2f51ecd6f";

export default node;
